import { Award, Heart, Sparkles } from 'lucide-react';
import { images } from '../../mock';

export default function About() {
  return (
    <section id="about" className="section-anchor py-20 md:py-28 bg-[#f6f3ea]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative fade-up">
          <div className="media-card rounded-3xl shadow-xl">
            <img
              src={images.about}
              alt="Working through finances with charts"
              className="w-full h-[420px] lg:h-[520px] object-cover"
            />
          </div>
          <div className="hidden md:block absolute -bottom-8 -right-6 w-44 h-44 rounded-3xl overflow-hidden shadow-xl border-4 border-white">
            <img
              src={images.ruralLandscape}
              alt="Rural NZ landscape"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="fade-up delay-2">
          <div className="brand-divider mb-5" />
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-stone-900 leading-tight">
            Personal service, practical advice.
          </h2>
          <p className="mt-5 text-stone-600 text-[17px] leading-relaxed">
            At Ask Away Accounting we pride ourselves on personalised accountant
            services with solutions tailored to your business needs. We service a
            wide range of customers from Dannevirke, Pahiatua, Ashhurst, Feilding
            and Palmerston North — and through cloud accounting we look after
            clients all over New Zealand.
          </p>
          <p className="mt-4 text-stone-600 text-[17px] leading-relaxed">
            Whether you run a small business, a farm or a growing property
            portfolio, our team is here to make the numbers simple.
          </p>

          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            <div className="bg-white rounded-2xl p-5 border border-stone-200">
              <Heart className="h-6 w-6 text-[#0b6b5b]" />
              <div className="mt-3 font-display font-semibold text-stone-900">Personable</div>
              <p className="text-xs text-stone-600 mt-1">Real people, no jargon.</p>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-stone-200">
              <Award className="h-6 w-6 text-[#0b6b5b]" />
              <div className="mt-3 font-display font-semibold text-stone-900">Experienced</div>
              <p className="text-xs text-stone-600 mt-1">20+ years in NZ accounting.</p>
            </div>
            <div className="bg-white rounded-2xl p-5 border border-stone-200">
              <Sparkles className="h-6 w-6 text-[#0b6b5b]" />
              <div className="mt-3 font-display font-semibold text-stone-900">Cloud Ready</div>
              <p className="text-xs text-stone-600 mt-1">Xero &amp; MYOB certified.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
